import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const DistributionManifestListPage = lazy(() => import('src/pages/distribution/list'));
const DistributionManifestUploadPage = lazy(() => import('src/pages/distribution/upload'));
const DistributionManifestDetailsPage = lazy(() => import('src/pages/distribution/details'));
const DistributionClientProfilePage = lazy(() => import('src/pages/distribution/profile'));

// ----------------------------------------------------------------------

export const distributionRoutes = [
  {
    path: 'distribution',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Navigate to="manifests" replace /> },
      {
        path: 'manifests',
        children: [
          { index: true, element: <DistributionManifestListPage /> },
          { path: 'upload', element: <DistributionManifestUploadPage /> },
          { path: ':id', element: <DistributionManifestDetailsPage /> },
        ],
      },
      { path: 'profile', element: <DistributionClientProfilePage /> },
    ],
  },
];
